module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-149.27b2d6e6.jpg";